import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import authentication from "./authentication";
import globalmessages from "./globalmessages";
import { OverviewState } from "./overview";
import { LatestNewsState } from "./LatestNews";
import { UserSettingsState } from "./UserSettings";

const rootReducer = combineReducers({
    authentication,
    globalmessages,
    OverviewState,
    LatestNewsState,
    UserSettingsState,
    routing: routerReducer
});

export default rootReducer;
